import React from 'react';
export const WebinarMCStickyBar = ({
  onClickCTA
}: {
  onClickCTA: () => void;
}) => {
  return <div className="fixed bottom-0 left-0 right-0 z-40 md:hidden bg-[#FDF6E8] border-t border-[#0E3A47]/10 shadow-[0_-2px_10px_rgba(14,58,71,0.08)]" data-id="element-476">
      <div className="px-4 pt-2 pb-3 text-center" data-id="element-477">
        <button onClick={onClickCTA} className="w-full bg-[#E8806E] hover:bg-[#D26E5C] text-white font-bold py-3 px-6 rounded-full transition-colors text-base shadow-md" data-id="element-478">
          Register for webinar
        </button>
        <div className="mt-2 flex justify-center" data-id="element-479">
          <div className="trustpilot-widget" data-locale="en-US" data-template-id="5419b6ffb0d04a076446a9af" data-businessunit-id="65017f0060003ffc450ac45e" data-style-height="20px" data-style-width="100%" data-token="23019ce4-308c-4f1c-8406-ce6ca64ac0c2" data-id="element-480">
            <a href="https://www.trustpilot.com/review/stresslessdogs.nl" target="_blank" rel="noopener" data-id="element-481">
              Trustpilot
            </a>
          </div>
        </div>
      </div>
    </div>;
};